export type AnyFunction = (...args: any[]) => any;
